<template>
  <van-sticky :offset-top="0">
    <demo-block :title="('')">
      <van-nav-bar :title="('水电管理')" :left-text="('返回')" left-arrow @click-left="this.$router.push('index')">
        <template #right>
          <van-icon v-if="paytype===0 || paytype ===1" name="wechat-pay" size="18" />
          <van-icon v-if="paytype===2" name="alipay" size="18" />
        </template>
      </van-nav-bar>
    </demo-block>
  </van-sticky>
  <demo-block v-if="active !== 2">
    <van-swipe
      :autoplay="3000"
      @change="onChange"
      style="height: 150px"
      ref="swipe"
    >
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <van-image :src="image.img" />
        {{ image.title }}
      </van-swipe-item>
    </van-swipe>
  </demo-block>
  <van-notice-bar
    v-if="errorcode"
    left-icon="volume-o"
    :text="errmsg"
  />
  <van-grid>
    <van-grid-item icon="cash-back-record" text="缴费" url="/#/energysave" />
    <van-grid-item icon="cluster" text="监控" url="/#/energymonitor" />
    <van-grid-item icon="location" text="设备" />
    <van-grid-item icon="setting" text="数据" url="/#/energychart"/>
  </van-grid>
  <van-cell-group title="水电信息" center inset>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="用电" name="1">
          <van-cell title="电表位置" value="1楼101-单控" />
          <van-cell title="当前度数" value="0.290" />
          <van-cell title="当前功率" value="220V"/>
          <van-cell title="设备id" value="110407010790"/>
          <van-cell-group title="" inset>
            <van-button
              plain
              hairline
              :icon="require('/assets/images/charge_online.png')"
            >
              送电
            </van-button>
            <van-button
              plain
              hairline
              :icon="require('/assets/images/charge_isuse.png')"
            >
              断电
            </van-button>
            <van-button
              plain
              hairline
              :icon="require('/assets/images/charge_takeup.png')"
            >
              刷新
            </van-button>
            
        </van-cell-group>
      </van-collapse-item>
      <van-collapse-item title="用水" name="2">
          <van-cell title="水表位置" value="1楼101-15口径" />
          <van-cell title="当前表数" value="0.2吨" />
          <van-cell title="当前流量" value="0"/>
          <van-cell title="设备id" value="910407010790"/>
          <van-cell-group title="" inset>
            <van-button
              plain
              hairline
              :icon="require('/assets/images/charge_online.png')"
            >
              送水
            </van-button>
            <van-button
              plain
              hairline
              :icon="require('/assets/images/charge_isuse.png')"
            >
              断水
            </van-button>
            <van-button
              plain
              hairline
              :icon="require('/assets/images/charge_takeup.png')"
            >
              刷新
            </van-button>
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>
  </van-cell-group>

  <van-row v-if="errorcode === false" justify="space-between" align="center" :style="userinfo.status === '挂失'?'background-color:#700000':''">
    <van-col>
      <van-row style="margin-bottom: 10px">
        <span v-if="isbind===false" color="ff0000" style="font-size: 19px;"> 
              Hi，
              <span v-if="paytype===0 || paytype ===1">微信用户</span>
              <span v-else-if="paytype===2">支付宝用户</span>
              <span v-else>匿名用户</span>
        </span>
      </van-row>
    </van-col>
  </van-row>

  <p align="center" style="margin-bottom:50px;">
    <a href="https://beian.miit.gov.cn" id="beian" target="_blank"> {{this.$store.state.beian}}</a>
  </p>
  <br>
  <van-tabbar v-model="active">
    <van-tabbar-item icon="home-o">主页面</van-tabbar-item>
    <van-tabbar-item to="/useroption" icon="home-o">我的</van-tabbar-item>
  </van-tabbar>
  <br>
  <van-dialog
    v-model:show="dialogShowChargeStation"
    title="充电桩列表"
    :show-cancel-button="false"
    :lazy-render="false"
  >
    <div style="height:300px;overflow-y: auto">
      <van-grid  clickable column-num="3">
        <van-grid-item  v-for="(item, index) in lsChargeStation"
          :key="index"
          @click="ToChargePort(item)"
          :icon="GetChargeStationIcon(item)" 
          :text="item.termname"
          class="menugrid" />
      </van-grid>
    </div>
  </van-dialog>
  
</template>

<script>
  import { requestGetSysInfo, requestGetUserBaseInfo, requestChargeStationList } from '../../api/api'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { IsBlank, GetBrowserType } from '../../utils/tools/index'
  // import qrcode from '../../utils/qrcode/index'

  

import {
  Grid,
  GridItem,
  Image,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Tag,
  Cell,
  CellGroup,
  Row,
  Col,
  CouponCell,
  CouponList,
  Popup,
  Icon,
  Dialog,
  Toast,
  NoticeBar,
  ActionBar,
  ActionBarButton,
  ActionBarIcon,
  Button,
  Sticky,
  NavBar,
  Circle,
  Collapse,
  CollapseItem
} from "vant";

export default {
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Sticky.name]: Sticky,
    [NavBar.name]: NavBar,
    [Col.name]: Col,
    [Row.name]: Row,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [ActionBar.name]: ActionBar,
    [ActionBarButton.name]: ActionBarButton,
    [ActionBarIcon.name]: ActionBarIcon,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Circle.name]: Circle,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  i18n: {
    "zh-CN": {
      text: "文字",
      route: "页面导航",
      gutter: "格子间距",
      square: "正方形格子",
      columnNum: "自定义列数",
      customContent: "自定义内容",
      urlRoute: "URL 跳转",
      vueRoute: "路由跳转",
      showBadge: "徽标提示",
      horizontal: "内容横排",
    },
    "en-US": {
      text: "Text",
      route: "Route",
      gutter: "Gutter",
      square: "Square",
      columnNum: "Column Num",
      customContent: "Custom Content",
      urlRoute: "URL",
      vueRoute: "Vue Router",
      showBadge: "Show Badge",
      horizontal: "Horizontal",
    },
  },
  watch: {
    active(val) {
      if (val === 1) {
        setTimeout(() => {
           // this.$router.push( '/useroption' + '?t111=' + new Date().getTime() );
        }, 500);
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.token,
      isbind: state => state.isbind,
      userinfo: state => state.userinfo,
      accesstoken: state => state.accesstoken,
      openid: state => state.openid,
      typekey: state => state.typekey
    }),
    ...mapGetters([
      'openidex',
      'hasopenid',
      'isReAuthLogin',
      'isGrid'
    ])
  },
  data() {
    return {
      activeNames: [],
      gradientColor: {
        '0%': '#3fecff',
        '100%': '#6149f6',
      },
      rate: 49,
      currentElec: 8.99,
      currentWater: 99.00,
      dialogShowChargeStation: false,
      errorcode: true,
      errmsg: '加载中...',
      headpic: '',
      showQrCode: false,
      loadcontent: '加载中...',
      isLoading: false,
      dialogIcon: '',
      dialogTitle: '进入模式',
      chartindex: 0,
      dialogInScene: false,
      showScene: false,
      active: 0,
      charttitle: "用水信息",
      chosenCoupon: -1,
      exchangedCoupons: [],
      images: [
        {img: require('/assets/images/energy001.png'), title: '水'},
        {img: require('/assets/images/energy002.png'), title: '电'},
        {img: require('/assets/images/energy003.png'), title: '能源'},
        {img: require('/assets/images/energy004.png'), title: '智能'}
      ],
      paytype: 0,
      menulist: [
        {menuid: 0, menuname: '扫码充电', icon: 'scan', link: '#/chargeqrcode', isshow: true, functionname: 'charge_qrcode', iconcolor: '#FF5733' },
        {menuid: 1, menuname: '选桩充电', icon: 'edit', link: '#/chargemachine', isshow: true, functionname: 'charge_select', iconcolor: '#FF5733' },
        {menuid: 2, menuname: '充电记录', icon: 'balance-pay', link: '#/chargeuselist', isshow: true, functionname: 'charge_uselist', iconcolor: '#FF5733' },
        {menuid: 3, menuname: '地图查询', icon: 'location-o', link: '#/chargemachinepos', isshow: true, functionname: 'charge_maps', iconcolor: '#FF5733' },
        {menuid: 4, menuname: '充电中', icon: 'upgrade', link: '#/chargeing', isshow: true, functionname: 'chargeing', iconcolor: '#FF5733' },
        {menuid: 5, menuname: '个人中心', icon: 'user-o',link: '#/chargechart', isshow: true, functionname: 'chargechart', iconcolor: '#FF5733' },
      ],
      qrcode: '',
      qrcodevaliddt: 0,
      qrcodeoversec: 0,
      menulist1: [],
      lsChargeStation: [],
      broadcastmsg: '本系统支持内部人员直接使用',
      ws: null,
      paymessage: '等待支付中...',
      qrcodeTimer: null,
      wsexit: false,
    };
  },
  
  mounted() {
    // this.paytype = GetBrowserType()
    console.log(GetBrowserType())
    console.log(this.getLocalLoginInfo())
    // 如果有errcode代表是有错误发生了，直接显示错误信息\
    var $errcode = this.$route.query.errcode
    var $errmsg = this.$route.query.errmsg
    console.log('___________________________________________')
      console.log('$errcode', $errcode)
      console.log('$errmsg', $errmsg)
      console.log('___________________________________________')
      console.log(IsBlank($errcode))
    if (IsBlank($errcode) === true) { // 为空
      this.errcode = false
      this.errmsg = '加载完成,检查token信息'
      this.errorcode = false
      // 如果accesstoken有信息，那就直接设置进去
      var $accesstoken = this.$route.query.accesstoken
      var $token = this.$route.query.localtoken
      console.log('___________________________________________')
      console.log('$token信息', $token)
      console.log('$accesstoken信息', $accesstoken)
      console.log('___________________________________________')
      if (IsBlank($accesstoken) === false) {
        console.log('去更新token')
        this.isbind = true
      } 
      this.GetBaseUserInfo()
      // this.GetSysInfo()
    } else {
      console.log('有错误信息出来了，不用跳转了')
      this.errcode = $errcode
      this.errmsg = $errmsg
    }
    console.log(this.userinfo)
    console.log(this.isbind)
    console.log(this.state)
    console.log('启动结束！')

  },
  methods: {
    ...mapActions([
      'getLocalLoginInfo',
      'getIsNeedAuthLogin',
      'clearAccessToken',
      'getBaseUserInfo'
    ]),
    scanCode() { // 扫描二维码
    },
    GetChargeStationIcon(r) {
      if (r) {
        if (r.stationtype==1) return require('/assets/images/charge_car'+ r.status +'.png') // 汽车充电桩
        else return require('/assets/images/charge_bike'+ r.status +'.png') // 电瓶车充电桩
      } else return 'info'

    },
    async ClickMenu(r) {
      console.log(r)
      if (r.menuid==1) {
        const res = await requestChargeStationList({accesstoken: this.$store.state.accesstoken})
        if(res.return_code==0) {
          this.lsChargeStation=res.data
          this.dialogShowChargeStation=true
        } else {
          Dialog.alert({
            title: '获取充电桩信息失败！',
            message: res.return_message,
          }).then(() => {
            console.log('onclose')
          });
        }
      } else {
        this.$router.push( r.link + '?t1=' + new Date().getTime());
      }
    },
    ToChargePort(r) {
      if (r.status==1) this.$router.push('#/chargemachine?poscode=' + r.poscode +'&t1=' + new Date().getTime());
      else {
        var statusName='未启用'
        if (r.status==0) statusName='不在线'
        Dialog.alert({
          title: '使用提醒',
          message: '充电桩 ['+r.termname+'] 处于 【'+ statusName +'】状态，不能使用!'
        });
      }
    },
    async GetBaseUserInfo(){
      const res = await requestGetUserBaseInfo({accesstoken: this.$store.state.accesstoken})
        if (res.return_code === '0')
        {
          this.$store.commit('updateUserInfo', res.data[0])
          this.menulist1 = []
          res.functionlist.forEach(f => {
            if (f.isshow == '1') {
              if (IsBlank(f.iconcolor)) f.iconcolor = '#FF5733'
              if(f.functionname === 'pay_lakala') {// 拉卡拉充值
                if (this.paytype ===0 || this.paytype === 1) {
                  f.functionmemo = '微信充值'
                  f.icon = 'wechat'
                  f.iconcolor= '#00ac84'
                } else if (this.paytype === 2) {
                  f.functionmemo = '支付宝充值'
                  f.icon = 'alipay'
                  f.iconcolor = '#108ee9'
                } else { 
                  console.log('不支持的充值方式')
                  return
                }
              }
              this.menulist1.push(f)
              return
            }
            });
          this.headpic = res.picserver + res.data[0].outid + '&t1=' + new Date().getTime();
          this.$store.state.userinfo.facepic = res.picserver + res.data[0].outid
        } else {
          Toast({
            message: res.return_message + ',去登录或者重新绑定！' ,
            icon: 'fail',
          });
          this.$router.push( '/bind' + '?t1=' + new Date().getTime());
        }
    },
    async GetSysInfo() {
      const param = {accesstoken: this.accesstoken}
      const res  = await requestGetSysInfo(param)
       if (res.return_code === '0') {
        console.log(res)
        this.images = res.bannerinfo
        this.$store.state.beian = res.beian
        this.$store.state.isenablewxpay = res.isenablewxpay
        this.$store.state.isenablealipay = res.isenablealipay
        document.title = res.systemname[0].dpname + ' 服务平台' 
        if (res.broadcastmsg.length>0) this.broadcastmsg = res.broadcastmsg[0].broadcastmsg
        // console.log(res)
      } else {
        Toast({
          message: res.return_message ,
          icon: 'fail',
        });
      }
    },
    async CheckBind() {
      // 先检查当前localtoken和accesstoken有没有绑定信息

    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000);
      } else {
        done();
      }
    },
    InScene() {
      console.log('ok')
      Toast({
        message: this.dialogTitle + '成功',
        icon: this.dialogIcon,
      });
    },
    onChangeScene(index) {
      this.showScene = false;
      this.chosenCoupon = index;
    },
    randomId(max = 999999) {
      return Math.floor(Math.random() * max) + 1;
    },
    onChange(index) {
      this.current = index;
    }
  },
};
</script>

<style lang="less">
.van-grid {
  display: flex;
  flex-wrap: wrap;
}
.menugrid {
  // display: flex;
  flex-wrap: wrap;
  background-color: transparent;
  margin-bottom: 5px;
  // margin-left: 3px;
}
.van-grid-item__content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    padding: var(--van-grid-item-content-padding);
    background: transparent;
}
.qrcodetext {
  margin-left: 5px;
  margin-top: 35px;
  color: #3c3c3f;
  font-size: 15px;
  font-family:"微软雅黑",Georgia,Serif;
}
.img1 {
  height: 60px;
}
.imgDialog {
  box-sizing: border-box;
  width: 100%;
  padding: 25px 20px 0;
}
</style>
